import React from 'react';
import classNames from "classnames"

import "./index.less"

function Tag(props) {

    const {
        children = "",
        type = "status",    //status attribute text edit
        color = "process"   //process success warning error end expired
    } = props

    const cls = classNames(type, color)

    return (
        <span className={`ikd-tag ${cls}`}>
            {children}
        </span>
    );
}

export default Tag;